export class SlackOAuthNotFoundError extends Error { }
